import { BACKEND_API_URL } from "../Config";
import { fetchWithAuth, handleApiResponse } from "../Utils";

export const fetchCaptcha = async (params = {}) => {
  const { auth, onSuccess, onError } = params;

  try {
    // 캡챠는 보통 permitAll이라 auth 없어도 되지만,
    // 프로젝트 공통 패턴을 위해 auth가 있으면 fetchWithAuth 사용
    const response = auth
      ? await fetchWithAuth(`${BACKEND_API_URL}/captcha`, { method: "GET" }, auth)
      : await fetch(`${BACKEND_API_URL}/captcha`, { method: "GET" });

    const data = await handleApiResponse(response, "fetchCaptcha");
    if (onSuccess) onSuccess(data);
    return data;
  } catch (error) {
    if (onError) return onError(error);
    throw error;
  }
};

// POST /captcha/verify body: { captchaId, captchaValue } -> { valid }
export const verifyCaptcha = async (params = {}) => {
  const { auth, captchaId, captchaValue, onSuccess, onError } = params;

  try {
    const payload = JSON.stringify({ captchaId, captchaValue });

    const response = auth
      ? await fetchWithAuth(
          `${BACKEND_API_URL}/captcha/verify`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: payload,
          },
          auth
        )
      : await fetch(`${BACKEND_API_URL}/captcha/verify`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: payload,
        });

    const data = await handleApiResponse(response, "verifyCaptcha");
    if (onSuccess) onSuccess(data);
    return data;
  } catch (error) {
    if (onError) return onError(error);
    throw error;
  }
};